import moment from 'moment';
import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import {
  UPDATE_SCHEDULE,
  SET_SCHEDULE,
  FETCH_SCHEDULE,
  SET_LAST_WATERED,
  SET_UPCOMING_WATERED,
  SET_CALENDAR_DATES,
  GET_SCHEDULE_FOR_DAY,
  SET_SCHEDULE_FOR_DAY,
  SET_CURRENT_WATERING,
  MODIFY_SCHEDULE,
  NEW_SCHEDULE,
  STOP_SCHEDULE_LOADER,
} from './types';

const INITIAL_STATE = Immutable({
  loading: false,
  data: [],
  updateSchedule: {
    step: 0,
    type: 'create',
    schedule: {},
    loading: false,
  },
  runningSchedule: [],
  calender: {},
  dayWiseSchedule: [],
  currentWatering: {},
});

const updateSchedule = (state, { payload }) => state.merge({
  ...state,
  updateSchedule: payload,
});

const stopScheduleLoader = (state) => state.merge({
  ...state,
  updateSchedule: {
    ...state.updateSchedule,
    loading: null,
  },
});

const setScheduleLoader = (state) => state.merge({
  ...state,
  updateSchedule: {
    ...state.updateSchedule,
    loading: true,
  },
});

const fetchSchedule = (state) => state.merge({
  ...state,
  loading: true,
});

const addSchedule = (state, { payload }) => state.merge({
  ...state,
  data: payload.filter((item) => !item.temporary),
  loading: false,
});

const setLastWatered = (state, { payload }) => {
  let zoneName = '';
  let duration = 0;
  const upcoming = payload.map((item) => {
    item.zones.forEach((zone) => {
      duration += zone.duration;
      zoneName += `${zone.value.name}, `;
    });
    return {
      ...item,
      type: 'Last Watered',
      zoneName,
      duration,
    };
  });
  return state.merge({
    ...state,
    runningSchedule: upcoming.concat(state.runningSchedule),
  });
};

const setUpcomingWatering = (state, { payload }) => {
  let zoneName = '';
  let duration = 0;
  const upcoming = payload.map((item) => {
    item.zones.forEach((zone) => {
      duration += zone.duration;
      zoneName += `${zone.value.name}, `;
    });
    return {
      ...item,
      type: 'Upcoming',
      zoneName,
      duration,
    };
  });
  return state.merge({
    ...state,
    runningSchedule: upcoming.concat(state.runningSchedule),
  });
};

const setWateringDates = (state, { payload }) => state.merge({
  ...state,
  calender: payload,
});

const getDayWiseSchedule = (state) => state.merge({
  ...state,
  dayWiseSchedule: null,
});

const setDayWiseSchedule = (state, { payload }) => state.merge({
  ...state,
  dayWiseSchedule: payload,
});

const setCurrentWatering = (state, { payload }) => state.merge({
  ...state,
  currentWatering:
      typeof payload === 'object' ? payload : { ...state.currentWatering, stopped: true },
});

const reducers = createReducer(INITIAL_STATE, {
  [FETCH_SCHEDULE]: fetchSchedule,
  [UPDATE_SCHEDULE]: updateSchedule,
  [SET_SCHEDULE]: addSchedule,
  [SET_LAST_WATERED]: setLastWatered,
  [SET_UPCOMING_WATERED]: setUpcomingWatering,
  [SET_CALENDAR_DATES]: setWateringDates,
  [GET_SCHEDULE_FOR_DAY]: getDayWiseSchedule,
  [SET_SCHEDULE_FOR_DAY]: setDayWiseSchedule,
  [SET_CURRENT_WATERING]: setCurrentWatering,
  [MODIFY_SCHEDULE]: setScheduleLoader,
  [NEW_SCHEDULE]: setScheduleLoader,
  [STOP_SCHEDULE_LOADER]: stopScheduleLoader,
});

export default reducers;
